export const REGISTER_USER = "register_user";
export const REGISTER_USER_CONFIRMATION = "register_user_confirmation";
export const GET_PROVIDERS = "get_providers";
export const REGISTER_USER_SUCCESSFUL = "register_user_successfull";
export const REGISTER_USER_FAILED = "register_user_failed";
export const REGISTER_PROVIDERS = "register_providers";
export const GET_TERMS = "get_terms";
export const REGISTER_TERMS = "register_terms";
export const RESET_VALUES = "reset_values"
